<template>
  <div class="padd">
    <div ref="wrapper" class="tab-wrap">
      <h1 @click="addCalss()">
        <p>
          变异汇总（可匹配药物）
        </p>

        <i
          class="iconfont"
          :class="isBoolean ? 'icon-up_medium' : 'icon-down_medium'"
        ></i>
      </h1>
      <div v-if="isBoolean">
        <div class="show-box"></div>
        <div class="tabs-box">
          <van-tabs
            v-model="activeName"
            background="none"
            color="#4B84FF"
            line-width="20"
            title-active-color="#2F354D"
            title-inactive-color="#9095A7"
            swipe-threshold="1"
            @change="handleChange"
          >
            <van-tab
              v-for="item in tab"
              :name="item.customerOrderCode"
              :key="item.format"
              :title="item.format"
              title-class="badge-parent"
            />
          </van-tabs>
        </div>
        <div class="null-box" v-if="isEmpty">
          <van-empty
            class="custom-image"
            image-size="100px"
            :image="require('../../assets/not.png')"
            description="未检出"
          />
        </div>
      </div>

      <PatientPageChildren v-if="isBoolean" :dataList="dataList" />
      <!-- <TwoClass v-if="activeName == 'B'" /> -->
      <!-- 注释弹框 -->
      <Notes ref="child" :notesText="notesText" />
    </div>
  </div>
</template>
<script>
import PatientPageChildren from "@/components/patientPageChildren.vue";
// import Notes from "@/components/notes.vue";
import isiOS from "@/utils/iosAn";

import { ByClass, findReportDate } from "@/api/reportQuery";

import { mapState } from "vuex";
export default {
  components: {
    PatientPageChildren,
    // Notes,
  },
  data() {
    return {
      isBoolean: true,
      isEmpty: false,
      notesText: {
        h1: "",
        p: "",
      },
      activeName: 1,
      tab: [],
      dataList: [],
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    sessionStorage.setItem("typeTem", this.activeName);
    this.getDate();
  },
  methods: {
    addCalss() {
      this.isBoolean = !this.isBoolean;
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "click",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({ name: "click", type: "" })
        );
      }
    },
    isNotes() {
      this.$refs.child.ishow();
    },
    // 获取报告日期接口
    async getDate() {
      try {
        let data = await findReportDate({
          // terminalCustomerNo: "P2101210291",
          terminalCustomerNo: this.$route.query.terminalCustomerNo,
        });
        console.log(data, "123");
        this.tab = data.data;
        this.getData(this.tab[0].customerOrderCode);
      } catch (error) {}
    },
    async getData(customerOrderCode) {
      try {
        let { data } = await ByClass({
          customerOrderCode:customerOrderCode,
          // terminalCustomerNo: "P2101210291",
          terminalCustomerNo: this.$route.query.terminalCustomerNo,
        });
        // console.log(data)
        this.dataList = data;

        if (this.dataList == "") {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      } catch (error) {}
    },
    handleChange(val) {
      console.log(val);
      this.getData(val);
      sessionStorage.setItem("typeTem", this.activeName);
    },
  },
};
</script>
<style lang="less" scoped>
.null-box {
  margin-top: -40px;
}
.padd {
  padding: 0 14px 10px;
  overflow: hidden;
}
.tab-wrap {
  // height: 790px;
  // padding-bottom: 30px;
  background: @background_color;
  border-radius: 10px;
  // margin-bottom: 20px;
  h1 {
    // height: 70px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    // line-height: 70px;
    padding: 24px 24px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    .ts-info {
      color: #a4a9bf;
      // position: absolute;
    }
    i {
      min-width: 16px;
      font-size: 14PX;
    }
  }
  // .tabs-box {
  //   height: 70px;
  //   line-height: 70px;
  //   padding-top: 10px;
  //   box-sizing: border-box;
  //   position: relative;
  //   /deep/.van-tabs__nav--line{
  //     padding-bottom: 10px;
  //   }
  //   &::before {
  //     content: "";
  //     position: absolute;
  //     z-index: 1;
  //     right: 0;
  //     top: 0;
  //     height: 100%;
  //     width: 22px;
  //     background: rgba(244, 248, 253, 0.7);
  //   }
  // }
}
/deep/.badge-parent {
  min-width: 40%;
  .van-info {
    background: none;
    color: #4b84ff;
    border: 0;
    top: 6px;
    right: -14px;
  }
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}

.tabs-box {
  padding-bottom: 30px;
  box-sizing: border-box;
  position: relative;
  /deep/.van-tabs__nav--line {
    padding-bottom: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    height: 100%;
    width: 22px;
    background: rgba(244, 248, 253, 0.7);
  }
}
</style>
